import TransferOwnershipSection from './TransferOwnershipSection';
import PrivacyDataSection from './PrivacyDataSection';
import type { PortalBootstrapData } from '../types/window';

type AdvancedTabProps = {
  bootstrap: PortalBootstrapData;
  onSessionExpired: () => void;
};

const AdvancedTab = ({ bootstrap, onSessionExpired }: AdvancedTabProps) => {
  return (
    <div className="subscription-tab subscription-tab--advanced">
      <PrivacyDataSection bootstrap={bootstrap} onSessionExpired={onSessionExpired} />
      <TransferOwnershipSection bootstrap={bootstrap} onSessionExpired={onSessionExpired} />
    </div>
  );
};

export default AdvancedTab;
